import { FC, ReactNode } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';

export type GrantEditConfirmVariant = 'signature_cancel' | 'signature_update';

export type FundraisingEditConfirmVariant = 'rounding_recalc';

export type ConfirmUpdateEventModalProps = {
  companyIncorporationConfirm?: boolean;
  eventName: ReactNode | string;
  fundraisingConfirmVariant?: FundraisingEditConfirmVariant;
  grantConfirmVariant?: GrantEditConfirmVariant;
  onClose: () => void;
  onSuccess: () => void;
};

export const ConfirmUpdateEventModal: FC<ConfirmUpdateEventModalProps> = ({
  onClose,
  onSuccess,
  eventName,
  companyIncorporationConfirm,
  fundraisingConfirmVariant,
  grantConfirmVariant,
}) => {
  const reviewMessageId =
    grantConfirmVariant === 'signature_update'
      ? 'GRANT_EDIT_CONFIRM_REVIEW_SIGNATURE_UPDATE'
      : grantConfirmVariant === 'signature_cancel'
        ? 'GRANT_EDIT_CONFIRM_REVIEW_SIGNATURE_CANCEL'
        : 'REVIEW_CHANGES';

  return (
    <div className="m-2 flex w-full max-w-[453px] flex-col gap-8 rounded bg-white p-4">
      <div className="flex flex-col gap-6">
        <span className="text-xl font-[550] text-gray-700">
          <AppFormattedMessage id="UPDATE" /> {eventName} <AppFormattedMessage id="EVENT" />?
        </span>
        <div className="flex flex-col gap-3 rounded-[4px] bg-white px-3 pb-[30px] pt-3">
          {companyIncorporationConfirm ? (
            <span className="whitespace-pre-line text-xs font-[450] text-gray-700">
              <AppFormattedMessage id="COMPANY_INCORPORATION_EDIT_CONFIRM" />
            </span>
          ) : (
            <>
              <span className="text-xs font-[450] text-gray-700">
                <AppFormattedMessage
                  id="CONFIRM_UPDATE_EVENT"
                  values={{
                    text: `${eventName}`,
                  }}
                />
              </span>
              <span className="text-xs font-[450] text-gray-700">
                <AppFormattedMessage id={reviewMessageId} />
              </span>
              {fundraisingConfirmVariant === 'rounding_recalc' && (
                <span className="text-xs font-[450] text-gray-700">
                  <AppFormattedMessage id="FUNDRAISING_EDIT_CONFIRM_ROUNDING_RECALC" />
                </span>
              )}
            </>
          )}
        </div>
      </div>
      <div className="flex h-11 w-full justify-end gap-3">
        <Button
          className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
          onClick={onClose}
          styleType="NONE"
        >
          <AppFormattedMessage id="CANCEL" />
        </Button>
        <Button
          className="h-full w-fit bg-brand-700 px-6 py-[10px] text-sm font-[550] text-white"
          onClick={onSuccess}
          styleType="NONE"
        >
          <AppFormattedMessage id="YES_UPDATE" />
        </Button>
      </div>
    </div>
  );
};
